// @flow

/**
 * Export `pages` entities.
 */

export const pages = {
  about: {
    en: 'about-us',
    pt: 'sobre-nos'
  },
  compliance: {
    en: 'compliance',
    pt: 'conformidade'
  },
  contacts: {
    en: 'contacts',
    pt: 'contactos'
  },
  forAgents: {
    en: 'for-agents',
    pt: 'agentes'
  },
  help: {
    en: 'help',
    pt: 'ajuda'
  },
  home: {
    en: '',
    pt: ''
  },
  howItWorks: {
    en: 'how-it-works',
    pt: 'como-funciona'
  },
  kycAndAml: {
    en: 'legal-and-compliance/kyc-and-aml',
    pt: 'legalidades-e-conformidade/kyc-and-aml'
  },
  lawEnforcement: {
    en: 'legal-and-compliance/law-enforcement',
    pt: 'legalidades-e-conformidade/aplicacao-da-lei'
  },
  licensedRepresentatives: {
    en: 'licensed-representatives',
    pt: 'representantes-licenciados'
  },
  privacy: {
    en: 'legal-and-compliance/privacy',
    pt: 'legalidades-e-conformidade/privacidade'
  },
  termsOfService: {
    en: 'legal-and-compliance/terms-of-service',
    pt: 'legalidades-e-conformidade/termos-de-servico'
  },
  unitransferTermsOfService: {
    en: 'legal-and-compliance/terms-of-service-unitransfer',
    pt: 'legalidades-e-conformidade/termos-de-servico-unitransfer'
  }
};



// WEBPACK FOOTER //
// ../src/core/entities/pages.js